export default "__VITE_ASSET__CFGiZwp$__"